import { Button } from "@/components/ui/button.tsx";
import { AuthenticatedUserProvider } from "@/providers/AuthenticatedUser/index.tsx";
import { ApolloProviderWrapper } from "@/providers/apollo.tsx";
import {
  ClerkProvider,
  RedirectToSignUp,
  SignOutButton,
  SignedOut,
} from "@clerk/clerk-react";
import { Outlet, createRootRoute, useNavigate } from "@tanstack/react-router";
import React from "react";
import { CLERK_PUBLISHABLE_KEY } from "../constants.ts";
const PosthogProviderWrapper = React.lazy(() =>
  import("@/providers/posthog.tsx").then((module) => ({
    default: module.PosthogProviderWrapper,
  })),
);
const Toaster = React.lazy(() =>
  import("@/components/ui/toaster.tsx").then((module) => ({
    default: module.Toaster,
  })),
);
const Particles = React.lazy(() => import("@/components/particles.tsx"));

export const Route = createRootRoute({
  component: RootLayout,
});

const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null
    : React.lazy(() =>
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

function RootLayout() {
  const navigate = useNavigate();

  return (
    <>
      <ClerkProvider
        routerPush={(to) => navigate({ to })}
        routerReplace={(to) => navigate({ to, replace: true })}
        publishableKey={CLERK_PUBLISHABLE_KEY}
      >
        <ApolloProviderWrapper>
          <AuthenticatedUserProvider>
            <PosthogProviderWrapper>
              <div className="dark">
                <SignOutButton>
                  <Button
                    variant="secondary"
                    className="z-1 fixed right-8 top-8"
                  >
                    Sign Out
                  </Button>
                </SignOutButton>
                <Outlet />
              </div>
            </PosthogProviderWrapper>
          </AuthenticatedUserProvider>
          <SignedOut>
            <RedirectToSignUp />
          </SignedOut>
        </ApolloProviderWrapper>
      </ClerkProvider>
      <Toaster />
      <Particles
        className="absolute inset-0 -z-10 bg-black"
        quantity={85}
        ease={70}
        size={0.2}
        staticity={25}
        color={"#ffffff"}
      />
      <TanStackRouterDevtools />
    </>
  );
}
